import { render, staticRenderFns } from "./UserListScreen.vue?vue&type=template&id=5f671fba&scoped=true&"
import script from "./UserListScreen.vue?vue&type=script&lang=js&"
export * from "./UserListScreen.vue?vue&type=script&lang=js&"
import style0 from "./UserListScreen.vue?vue&type=style&index=0&id=5f671fba&scoped=true&lang=css&"
import style1 from "./UserListScreen.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f671fba",
  null
  
)

component.options.__file = "UserListScreen.vue"
export default component.exports